<template>
  <div>
    <v-menu v-model="show" offset-y disable-keys persistent transition="scale-transition"
      bottom :close-on-click="false" :close-on-content-click="false" content-class="active-calls"
      activator=".sipua-client-btn" :min-width="minWidth" max-width="406"
      :nudge-left="moveLeft ? 740 : 0">
      <v-list nav>
        <Call v-for="(call, idx) in sipuaSess" :key="idx" :call="call"
          @call-hangup="callHangup"
          @active-call-dialpad="dialpadInit($event)"/>
      </v-list>
    </v-menu>
    <Dialpad @close-dialpad="closeDialpad" :call-id="dialpadCid" :show="showDialpad"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Call from './call.vue'
import Dialpad from './dialpad.vue'

export default {
  name: 'active-calls',
  data () {
    return {
      recCall: null,
      showRecorder: false,
      showRecDownload: false,
      recURL: null,
      showDialpad: false,
      dialpadCid: ''
    }
  },
  components: { Call, Dialpad },
  computed: {
    ...mapGetters({
      canCallRecord: 'permissions/canCallRecord',
      sipuaSess: 'sipuaSess',
      showConfMembersPane: 'conferences/memPaneShow'
    }),
    minWidth: function () {
      return this.canCallRecord() ? 396 : 370
    },
    show: {
      get: function () {
        return this.sipuaSess.length > 0
      },
      set: function (val) {
      }
    },
    moveLeft: function () {
      return this.showConfMembersPane
    }
  },
  methods: {
    dialpadInit: function (callid) {
      this.dialpadCid = callid
      this.showDialpad = true
    },
    closeDialpad: function () {
      this.dialpadCid = ''
      this.showDialpad = false
    },
    callHangup: function () {
      // callbacks when one of the calls hangup.
      // when there is no more calls then make sure
      // that dialpad is closed
      if (this.sipuaSess?.length > 0) {
        return
      }
      this.showDialpad = false
    }
  }
}
</script>

<style scoped>
.active-call-time {font-size: 11px}
.active-call-name {font-size: 12px}
.active-calls {border-radius: 20px}
</style>
